var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 0.333252C5.10834 0.333252 0.333313 5.10827 0.333313 10.9999C0.333313 16.8916 5.10834 21.6666 11.0001 21.6666C16.8916 21.6666 21.6666 16.8916 21.6666 10.9999C21.6666 5.10827 16.8916 0.333252 11.0001 0.333252ZM14.5986 13.0901C15.0153 13.5068 15.0153 14.1818 14.5986 14.5985C14.1817 15.0154 13.5068 15.015 13.0902 14.5985L11 12.5082L8.90971 14.5985C8.49278 15.0154 7.81793 15.015 7.40136 14.5985C6.98469 14.1818 6.98469 13.5068 7.40136 13.0901L9.49162 10.9998L7.40136 8.90965C6.98469 8.49298 6.98469 7.81796 7.40136 7.4013C7.81802 6.98463 8.49305 6.98463 8.90971 7.4013L11 9.49156L13.0902 7.4013C13.5069 6.98463 14.1819 6.98463 14.5986 7.4013C15.0153 7.81796 15.0153 8.49298 14.5986 8.90965L12.5083 10.9998L14.5986 13.0901Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundClose);
export default __webpack_public_path__ + "static/media/round-close.2c6b94ed.svg";
export { ForwardRef as ReactComponent };